import moment from "moment";
import VuetableFieldCheckbox from "vuetable-2/src/components/VuetableFieldCheckbox.vue";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';

export default [
    {
      name: VuetableFieldCheckbox,
      title: "checkbox",
      width: "10px",
      togglable: false,
      dataClass: "vertical-align-top",
      disabled: function (rowData) {
        return false;
      }
    },
    {
        id: 'channel',
        name: 'sales_channel_logo',
        title: i18n.t('Ch.'),
        dataClass: "vertical-align-top",
        titleClass: "",
        // formatter: value => {
        //     if(value.length == 0){
        //         value = require('@/assets/images/icon-gosell.png');
        //     }
        //     return '<div class="position-relative overflow-hidden" style="height: 25px; width: 25px;"><img class="rounded w-100 h-100" src="' + value +'" style="object-fit: cover;" /></div>';
        // }
    },
    {
        name: "image",
        title: i18n.t('Image'),
        dataClass: "vertical-align-top",
        titleClass: "",
    },
    {
        name: "name",
        title: i18n.t('Product Name'),
        dataClass: "vertical-align-top",
        titleClass: "",
    },
    {
        name: "quantity",
        title: i18n.t('QTY'),
        width:'100px',
        dataClass: "vertical-align-top",
        titleClass: "text-uppercase",
    },
    {
        name: "action",
        title: i18n.t('Action'),
        visible: true,
        dataClass: "vertical-align-top",
        titleClass: "",
    }


];



// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/assets/FieldsRestockItem.js